module.exports = require('./head');



//////////////////
// WEBPACK FOOTER
// ../sdk/map/node_modules/lodash/first.js
// module id = 573
// module chunks = 0